export default (function (_ref) {
  var operator = _ref.operator,
      values = _ref.values;

  if (operator === 'empty') {
    return {
      operator: 'eq',
      values: [null]
    };
  } else if (operator === 'notEmpty') {
    return {
      operator: 'neq',
      values: [null]
    };
  }

  return {
    operator: operator,
    values: values
  };
});